// extracted by mini-css-extract-plugin
module.exports = {"row":"BuildTypeOverview__row--Ll","title":"BuildTypeOverview__title--F3","container":"BuildTypeOverview__container--ZI"};